import { cva } from 'class-variance-authority';
import { clsxMerge } from '../../util';

export interface SpinnerProps {
  size: 'small' | 'medium' | 'large' | 'extra-large';
  focusable: boolean;
  label: string;
  ariaLive?: 'polite' | 'assertive' | 'off';
  className?: string;
}

const spinnerVariants = cva(
  'ds-rounded-full ds-border-t-acuity-blue ds-border-x-acuity-blue ds-border-b-neutrals-transparent ds-border-solid ds-animate-spin',
  {
    variants: {
      size: {
        small: ['ds-w-4', 'ds-h-4', 'ds-border'],
        medium: ['ds-w-5', 'ds-h-5', 'ds-border-2'],
        large: ['ds-w-7', 'ds-h-7', 'ds-border-[3px]'],
        'extra-large': ['ds-w-[6.5rem]', 'ds-h-[6.5rem]', 'ds-border-[6px]']
      }
    }
  }
);

const spinnerContainerVariants = cva(
  'preflight ds-inline-block ds-rounded focus-visible:ds-outline-none focus-visible:ds-ring-2 focus-visible:ds-ring-acuity-blue',
  {
    variants: {
      size: {
        small: 'ds-p-1',
        medium: 'ds-p-2',
        large: 'ds-p-3',
        'extra-large': 'ds-p-4'
      }
    }
  }
);

const Spinner = ({
  size = 'medium',
  focusable = true,
  label = '',
  ariaLive = 'assertive',
  className = ''
}: SpinnerProps) => {
  return (
    <div
      tabIndex={focusable ? 0 : undefined}
      aria-label={label}
      aria-live={ariaLive}
      className={
        focusable
          ? clsxMerge(spinnerContainerVariants({ size }), className)
          : `preflight ds-rounded ${className}`
      }
      role="status"
    >
      <div className={clsxMerge(spinnerVariants({ size }))} />
    </div>
  );
};

export default Spinner;
